// extracted by mini-css-extract-plugin
export default {"gauge":"RiskGauge_gauge__q0VRa","segment":"RiskGauge_segment__X8z0C","needle":"RiskGauge_needle__bk9av","label":"RiskGauge_label__+WE2T"};